<template>
  <div>
    {{ colValue }}
  </div>
 </template>
 
 <script>
 import { createUUID } from "/src/utils/util";
 export default {
   name: "PrimaryColumnTemplate",
   props: {
   },
   data() {
      return {
        data: {},
      };
    },
   computed:{
     colValue(){
       let field = this.data.column.field;
         if (this.data[field]) {
           return this.data[field];
         } else {
           return createUUID();
         }
     }
   },
   methods: {
    
   },
 };
 
 </script>
 
 <style>
 </style>